import dispatchEvent from '../utils/dispatch-event';
import { addToCart } from '../utils/cart';
import { DrawerEvent } from "../enums/event";
import { handlePromotions } from "../utils/promotions";

class ProductAddToCartButton extends HTMLElement {
  constructor() {
    super();

    this.atcBtn = this.querySelector('[data-atc-btn]');
    this.cartDrawer = document.querySelector('[data-drawer="cart"]');

    this.atcBtn.addEventListener('click', event => {
      event.preventDefault();

      const { id } = JSON.parse(this.atcBtn.dataset.productVariant);

      const rechargeWidget = document.querySelector('recharge-subscription-widget');
      let sellingPlan = '';
      console.log('Recharge widget:', rechargeWidget);
      
      if (rechargeWidget && rechargeWidget.shadowRoot) {
        // Find the selected purchase option (subscription or onetime)
        const selectedOption = rechargeWidget.shadowRoot.querySelector('.rc-purchase-option[rc-selected]');
        console.log('Selected purchase option:', selectedOption);

        if (selectedOption) {
          // Check if it's a subscription option
          const input = selectedOption.querySelector('input[type="radio"]');
          console.log('Radio input in selected option:', input);

          if (input && input.value === 'subscription') {
            // Find the rc-selling-plans element
            const sellingPlans = selectedOption.querySelector('rc-selling-plans');
            console.log('rc-selling-plans:', sellingPlans);

            if (sellingPlans && sellingPlans.shadowRoot) {
              // Find the checked selling plan input inside the shadow root
              const checkedPlan = sellingPlans.shadowRoot.querySelector('input[name="rc_plan"]:checked');
              console.log('Checked selling plan input:', checkedPlan);

              if (checkedPlan && checkedPlan.value) {
                sellingPlan = checkedPlan.value;
                console.log('Selling plan value:', sellingPlan);
              } else {
                console.log('No checked selling plan input found or no value.');
              }
            } else {
              console.log('No rc-selling-plans or shadowRoot found.');
            }
          } else {
            console.log('Selected option is not subscription or input not found.');
          }
        } else {
          console.log('No selected purchase option found.');
        }
      } else {
        console.log('Recharge widget or its shadowRoot not found.');
      }

      const productVariant = JSON.parse(this.atcBtn.dataset.productVariant);
      const productId = productVariant.product_id || this.atcBtn.dataset.productId;
      const variantId = id;
      const productPrice = productVariant.price || 0;

      addToCart(
        {
          items: [
            {
              id,
              quantity: 1,
              selling_plan: sellingPlan,
            },
          ],
        }
      ).then((response) => {
        if (response.status == 422) {
          this.atcBtn.disabled = true;
          this.atcBtn.textContent = window.translations.product.form.outOfStock;
        } else {
          dispatchEvent('cart:quantity-updated', document);
          
          // Call handlePromotions with product info after cart is updated
          // Wait a bit for cart_items to be updated
          setTimeout(() => {
            if (window.cart_items && handlePromotions) {
              console.log('🎁 [PRODUCT ADD CART] Calling handlePromotions with:', { productId, variantId, productPrice });
              handlePromotions(productId, variantId, productPrice);
            }
          }, 100);

          this.atcBtn.disabled = true;
          this.atcBtn.classList.toggle('[&:before]:hidden');
          this.atcBtn.textContent = window.translations.product.form.addedToCart;

          dispatchEvent(DrawerEvent.Toggle, this.cartDrawer, {
            detail: {
              drawerName: 'cart',
            },
          });

          setTimeout(() => {
            this.atcBtn.disabled = false;
            this.atcBtn.classList.toggle('[&:before]:hidden');
            this.atcBtn.textContent = window.translations.product.form.addToCart;
          }, 3000);
        }
      });
    });
  }
}

customElements.define('product-add-cart', ProductAddToCartButton);
